import { render, staticRenderFns } from "./AdDetails.vue?vue&type=template&id=5817c130&scoped=true&lang=pug"
import script from "./AdDetails.js?vue&type=script&lang=js&external"
export * from "./AdDetails.js?vue&type=script&lang=js&external"
import style0 from "./AdDetails.vue?vue&type=style&index=0&id=5817c130&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5817c130",
  null
  
)

export default component.exports